module.exports = __webpack_public_path__ + "static/favicon-71b77bbb37629175b88c6fa793ed6563.ico";